<template>
  <span class="d-inline">
    <cvc-frequency-input
      class="mr-2 d-inline-block height-20 width-120"
      :show-icon="false"
      :super-dense="true"
      :items="[
        { text: 'minutes', value: 60 },
        { text: 'hours', value: 3600 },
      ]"
      v-model="offset"
    />

    <v-select
      class="mx-2 d-inline-block height-20 width-110"
      required
      hide-details
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="beforeOrAfter"
      :items="beforeOrAfterOptions"
    />

    <v-select
      class="mx-2 d-inline-block height-20 width-110"
      required
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="startOrEnd"
      :items="startOrEndOptions"
      :error-messages="errorMessages.start_or_end_errors"
    />

    <v-select
      class="mx-2 d-inline-block height-20 width-90"
      required
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="indexed"
      :error-messages="errorMessages.index_or_range_errors"
      :items="indexedOptions"
    >
      <template v-slot:item="{ item }">
        <div v-html="item.text" />
      </template>
      <template v-slot:selection="{ item }">
        <div v-if="item.value !== 'nth'">
          {{ item.text }}
        </div>
        <div v-else class="d-inline-flex height-20">
          <span>the</span>
          <v-text-field
            required
            dense
            single-line
            type="number"
            style="margin-top: -1px"
            class="ml-2 width-30 height-20 select-field-no-underline text-field-no-input-padding text-field-no-input-arrows"
            :min="1"
            :max="99"
            v-model="index"
          />
          <span>{{ indexOrdinal }}</span>
        </div>
      </template>
    </v-select>

    <v-select
      v-if="indexed === 'first'"
      class="mx-2 d-inline-block height-20"
      required
      hide-details
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="range"
      :items="rangeOptions"
      :class="{ 'width-150': range, 'width-40': !range }"
    />

    <span>window of opportunity on</span>
    <cvc-date-input
      class="d-inline-block height-20 width-110"
      :icon-height="20"
      :height="20"
      :width="100"
      v-model="displayDate"
      :allowed-dates="allowedDisplayDates"
      :error-messages="errorMessages.display_date_errors"
    />
  </span>
</template>

<script>
import CvcFrequencyInput from "@/components/CvcFields/CvcFrequencyInput";
import { parseISO, endOfToday, format } from "date-fns";
import CvcDateInput from "@/components/CvcFields/CvcDateInput";

const todayEnd = endOfToday();

export default {
  name: "Woos",
  components: { CvcDateInput, CvcFrequencyInput },
  props: {
    errorMessages: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      offset: 60,
      beforeOrAfter: "after",
      beforeOrAfterOptions: [
        { text: "before the", value: "before" },
        { text: "after the", value: "after" },
      ],
      startOrEnd: null,
      startOrEndOptions: [
        { text: "start of", value: "start" },
        { text: "end of", value: "end" },
      ],
      indexed: null,
      index: "1",
      indexedOptions: [
        { text: "the first", value: "first" },
        { text: "the last", value: "last" },
        { text: "the nth", value: "nth" },
      ],
      range: null,
      rangeOptions: [
        { text: "...", value: null },
        { text: "early morning", value: { start: 14401, end: 25200 } },
        { text: "morning", value: { start: 25201, end: 43200 } },
        { text: "afternoon", value: { start: 43201, end: 61200 } },
        { text: "evening", value: { start: 61201, end: 79200 } },
        { text: "night", value: { start: 79201, end: 100800 } },
      ],
      displayDate: "",
    };
  },
  computed: {
    indexOrdinal() {
      if (this.index === "") return "";
      if (this.index === "1") return "st";
      if (this.index === "2") return "nd";
      if (this.index === "3") return "rd";
      return "th";
    },
    action() {
      // if (this.offset === null || this.beforeOrAfter === null || this.startOrEnd === null
      //     || this.indexed === null || this.displayDate === null) return null;

      let displayDate = "";
      try {
        displayDate = parseISO(this.displayDate + "T00:00:00Z").toISOString();
      } catch (e) {}

      let ret = {
        offset: this.offset * (this.beforeOrAfter === "before" ? -1 : 1),
        start_or_end: this.startOrEnd,
        display_date: displayDate,
      };

      switch (this.indexed) {
        case "first":
          if (this.range) {
            ret["ranges"] = [this.range];
          } else {
            ret["index"] = 0;
          }
          break;
        case "last":
          ret["index"] = -1;
          break;
        case "nth":
          ret["index"] = parseInt(this.index) - 1;
          break;
      }

      return ret;
    },
  },
  methods: {
    allowedDisplayDates(val) {
      const displayDate = parseISO(val);
      return displayDate > todayEnd;
    },
  },
  watch: {
    action(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.offset = val.offset ?? 0;
      this.startOrEnd = val.start_or_end ?? "";
      this.displayDate = val.displayDate ?? "";
      this.index = val.index ?? undefined;
      this.ranges = val.ranges ?? undefined;
    },
  },
};
</script>

<style scoped>
.input-field {
  height: 20px;
  display: inline-block;
}
</style>
